function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(1 1)",
  stroke: "#637280",
  strokeWidth: 1.6,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("ellipse", {
  cx: 5.25,
  cy: 5.409,
  rx: 5.25,
  ry: 5.409
}), React.createElement("path", {
  d: "M2.408 9.96L1.5 17l3.75-2.318L9 17l-.908-7.047"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 13,
    height: 19
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/rewards.1c42826d.svg";
export { SvgComponent as ReactComponent };